// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-navbar[data-v-14a5e526]{position:fixed;top:0;left:0;width:100%;z-index:50;box-shadow:0 2px 5px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
